import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let accessToken = null;
export const setAccessToken = (t) => {
  accessToken = t;
};
api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

// Scarica un export (PDF/Excel) con il token di autenticazione e lo apre nel browser.
export async function scaricaFile(url, onError) {
  try {
    const res = await api.get(url.startsWith(API) ? url.slice(API.length) : url, { responseType: "blob" });
    const cd = res.headers["content-disposition"] || "";
    const m = /filename="?([^";]+)"?/.exec(cd);
    const nome = m ? decodeURIComponent(m[1]) : "export";
    const blobUrl = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  } catch (e) {
    let msg = "Download non riuscito";
    try {
      const txt = await e.response?.data?.text?.();
      if (txt) msg = formatApiErrorDetail(JSON.parse(txt).detail);
    } catch { /* ignora */ }
    if (onError) onError(msg);
    else throw new Error(msg);
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
